import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AppContext';
import { Button } from '../components/ui/button';
import { Loader2, CheckCircle2, LogIn } from 'lucide-react';

// Temporary direct login page for debugging mobile auth issues
const DirectLogin = () => {
  const navigate = useNavigate();
  const { updateUser } = useAuth();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);

  const handleDirectLogin = async () => {
    setLoading(true);
    setError(null);
    
    try {
      // Use the current session token for yocteau@gmail.com
      const sessionToken = 'nt2zmAe_QEoCR4NWJ5EritJ470_hsAeB2d8II6MQEPc';
      
      // Store in localStorage
      localStorage.setItem('session_token', sessionToken);
      
      // Fetch user data
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/me`, {
        headers: {
          'X-Session-Token': sessionToken
        }
      });
      
      if (response.ok) {
        const userData = await response.json();
        updateUser(userData);
        setSuccess(true);
        
        // Redirect after short delay
        setTimeout(() => {
          if (userData.role === 'coach') {
            navigate('/coach', { replace: true });
          } else {
            navigate('/dashboard', { replace: true });
          }
        }, 1000);
      } else {
        setError('Session expirée. Veuillez vous reconnecter normalement.');
      }
    } catch (err) {
      setError('Erreur de connexion: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center p-6">
        <div className="text-center">
          <CheckCircle2 className="w-16 h-16 text-primary mx-auto mb-4" />
          <h2 className="font-heading text-2xl uppercase text-foreground mb-2">
            Connexion réussie!
          </h2>
          <p className="text-muted-foreground">Redirection en cours...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6">
      <div className="text-center max-w-sm">
        <img 
          src="/icons/icon-192x192.png" 
          alt="YUMIX" 
          className="w-32 mx-auto rounded-xl mb-6"
        />
        <h1 className="font-heading text-2xl uppercase text-foreground mb-2">
          Connexion Directe
        </h1>
        <p className="text-muted-foreground mb-6 text-sm">
          Page temporaire pour Coach Yuri (yocteau@gmail.com)
        </p>
        
        {error && (
          <div className="bg-destructive/20 border border-destructive/50 rounded-lg p-3 mb-4">
            <p className="text-sm text-destructive">{error}</p>
          </div>
        )}
        
        <Button 
          onClick={handleDirectLogin}
          disabled={loading}
          className="w-full bg-primary text-primary-foreground font-heading uppercase"
          size="lg"
        >
          {loading ? (
            <Loader2 className="w-5 h-5 animate-spin mr-2" />
          ) : (
            <LogIn className="w-5 h-5 mr-2" />
          )}
          Se connecter comme Coach Yuri
        </Button>
        
        <p className="text-xs text-muted-foreground mt-6">
          Cette page est temporaire pour résoudre les problèmes d'authentification sur mobile.
        </p>
      </div>
    </div>
  );
};

export default DirectLogin;
